import { globalStyle } from "../../global/Utils";

export const StatCard = ({ title, value, icon, Navigate }) => {
  return (
    <button
      disabled={(value ?? 0) === 0}
      className="w-full cursor-pointer disabled:cursor-not-allowed disabled:opacity-100"
      onClick={Navigate}
    >
      <div
        className="p-5 rounded-xl shadow-xl flex items-center gap-4"
        style={{
          background: globalStyle.bgColorWhite,
        }}
      >
        <div
          className="w-12 h-12 flex items-center justify-center rounded-lg text-white text-xl"
          style={{
            background: globalStyle.buttonColor,
          }}
        >
          {icon}
        </div>
        <div>
          <p
            className="text-base mb-1"
            style={{ fontFamily: globalStyle.fontFamilyParagraph }}
          >
            {title}
          </p>
          <h2
            className="text-2xl font-semibold"
            style={{ fontFamily: globalStyle.fontFamilyHeading }}
          >
            {value ?? 0}
          </h2>
        </div>
      </div>
    </button>
  );
};
